/**
 *
 * How to use :
 *

import Wishlist from "@core/wishlist";

Wishlist.save(customerId, 'productHandle', variantId).then((data) => {
  console.log('data:', data)
  if(data.success) {
    // act well with success
  } else {
    // handles error
  }
});

Wishlist.all(customerId).then()...

 *
 */

const METHODS = {
  ALL: "wistlist/all",
  SAVE: "wistlist/save",
  CHECK: "wistlist/check",
  DELETE: "wistlist/delete"
};

const API_ENDPOINT = `https://207ouest-api.vercel.app/api/shopify/customers`;
const PRODUCT_VARIANT_DELIMITER = "|";

class Wishlist {
  async all(customerID) {
    return await this._fetch(METHODS["ALL"], customerID);
  }

  async check(customerID, productHandle, variantID) {
    return await this._fetch(METHODS["CHECK"], customerID, productHandle, variantID);
  }

  async save(customerID, productHandle, variantID) {
    return await this._fetch(METHODS["SAVE"], customerID, productHandle, variantID);
  }

  async delete(customerID, productHandle, variantID) {
    return await this._fetch(METHODS["DELETE"], customerID, productHandle, variantID);
  }

  async _fetch(method = null, customerID, productHandle = null, variantID = null) {
    let response;

    if(!method) return { succes: false, error: 'No method provided'};

    // default body
    const body = { customerID: customerID };

    // append productID and variantID if provided
    if (productHandle) body.productHandle = productHandle;
    if (variantID) body.variantID = variantID;

    const options = {
      method: "post",
      headers: {
        "Content-Type": "application/json",
        "x-shopify-topic": method
      },
      body: JSON.stringify(body)
    };

    try {
      response = await fetch(API_ENDPOINT, options)
        .then((response) => {
          if (response.ok) { return response.json(); } else { return null }
        })
        .then((json) => {
          return json;
        });
    } catch (error) {
      response = { success: false, error: error };
    }

    return response;
  }
}

const SINGLETON = new Wishlist();

export default SINGLETON;
